import React from 'react';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useFavorites } from '../context/FavoritesContext';
import ProductCard from '../components/products/ProductCard';
import './Favorites.css';

function Favorites() {
  const { favorites, loading } = useFavorites();
  const { user } = useAuth();

  if (loading) {
    return (
      <div className="favorites-page page-transition">
        <Container>
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Yükleniyor...</span>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  if (!favorites || favorites.length === 0) {
    return (
      <div className="favorites-page page-transition">
        <Container>
          <Alert variant="info">
            Henüz favori ürününüz bulunmuyor. <Link to="/products">Ürünleri keşfedin</Link>.
          </Alert>
        </Container>
      </div>
    );
  }

  return (
    <div className="favorites-page page-transition">
      <Container>
        <h2 className="mb-4">Favorilerim</h2>
        <Row xs={1} sm={2} md={3} lg={4} className="g-4">
          {favorites.map((favorite) => {
            const productWithModels = {
              ...favorite.product,
              phone_models: favorite.phone_models.map(model => ({
                id: model.id,
                name: `${model.brand} ${model.model_name}`,
                brand: model.brand,
                model_name: model.model_name,
                is_active: true
              }))
            };
            
            return (
              <Col key={favorite.id}>
                <ProductCard 
                  product={productWithModels}
                  isFavorite={true}
                  showFavoriteButton={true}
                  showAddToCartButton={true}
                />
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
}

export default Favorites; 